import {
  getToken,
  setToken,
  removeToken
} from '@/utils/Token'
import {
  passwordLogin,
  codeLogin,
  getuser,
  onekeylogin,
  WechatLogin,
  getPlatformShopApi
} from '@/api/user'
import { getUserInte, getUsersurplusApi } from '@/api/pay'
import router from '@/router'
import {
  getMainPlatform,
  setMainPlatform,
  setFirstLogin,
  getFirstLogin,
  setExchangeCouponInfo,
  getExchangeCouponInfo,
  getPaltShopId,
  setPaltShopId
} from '@/utils/auth'

import { couponAndLoginApi } from '@/api/userCoupon'

const PlatForm = process.env.VUE_APP_PLATFORM

// token 处理
function TokenHandle(data) {
  const {
    token,
    refresh_token,
    refresh_token_expiresat,
    expiresat
  } = data
  setToken({
    Token: token,
    Refresh_token: refresh_token,
    Refresh_token_expiresat: refresh_token_expiresat,
    Expiresat: expiresat
  })
}

// 登录后的处理
function loginAfterHandle({ commit, state }) {
  // 第一次登陆设定
  commit('firstLogin')
}

const state = {
  token: getToken(),
  userInfo: '',
  userInte: '',
  userSurplus: '',
  mianPlatform: getMainPlatform() || '', // 主平台,
  paltShopId: getPaltShopId() || '', // 商铺id
  welfareCards: [], // 福利卡,
  storedValueCards: [], // 储值卡
  exchangeCardInfo: getExchangeCouponInfo() || {} // 兑换卡信息
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  set_user_inte: (state, userInte) => {
    state.userInte = userInte
  },
  SET_USER_SURPLUS: (state, userSurplus) => {
    state.userSurplus = userSurplus
  },
  // 切换平台 parm 平台id,shopId
  set_main_platform: (
    state,
    { platformId, platShopId }
  ) => {
    console.log(platformId, platShopId)
    setMainPlatform(platformId)
    setPaltShopId(platShopId)
    state.mianPlatform = platformId
    state.paltShopId = platShopId
  },
  SET_EXCHANGE_COUPON_INFO: (state, exchangeCardInfo) => {
    setExchangeCouponInfo(exchangeCardInfo)
    state.exchangeCardInfo = exchangeCardInfo
  },
  // 清空平台
  clean_main_platform: state => {
    setMainPlatform('')
    setPaltShopId('')
    state.mianPlatform = ''
    state.paltShopId = ''
  },
  // 设定是否第一次登陆
  firstLogin: state => {
    // 1 表示第一次登陆 2 不是第一次登陆
    const isFirstLogin = getFirstLogin()
    if (!isFirstLogin) {
      setFirstLogin(1)
      return
    } else {
      if (Number(isFirstLogin) === 1) {
        setFirstLogin(2)
      }
    }
  }
  // 检测是否登录
  // isLogin: (state) => {
  //   if (state.token) {
  //     return true
  //   }
  //   return false
  // }
}

const actions = {
  // 登录后

  // 一键登录
  oneKeyLogin({ state, commit }, userInfo) {
    const { phone, code } = userInfo
    return new Promise((resolve, reject) => {
      onekeylogin({
        phone: phone,
        code: code,
        wechatKey: state.wechatkey
      })
        .then(response => {
          TokenHandle({
            token: response.data.data.token,
            refresh_token: response.data.data.refresh_token,
            refresh_token_expiresat:
              response.data.data.refresh_token_expiresat,
            expiresat: response.data.data.expiresat
          })
          loginAfterHandle({ commit, state })
          // 第一次登陆设定
          // setToken({
          //   authorization: response.data.data.token,
          //   refresh_token: response.data.data.refresh_token,
          //   refresh_token_expiresat:
          //     response.data.data.refresh_token_expiresat,
          //   expiresat: response.data.data.expiresat
          // })
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 密码登录
  passwordLogin({ commit, state }, userInfo) {
    const { phone, pwd } = userInfo
    return new Promise((resolve, reject) => {
      passwordLogin({ username: phone, password: pwd })
        .then(response => {
          TokenHandle(response.data.data)
          loginAfterHandle({ commit, state })

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 验证码登录
  codeLogin({ commit, state }, userInfo) {
    const { phone, code } = userInfo
    return new Promise((resolve, reject) => {
      codeLogin({ phone: phone, code: code })
        .then(response => {
          TokenHandle(response.data.data)
          loginAfterHandle({ commit, state })

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取用户信息
  getUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.userInfo === '') {
        getuser()
          .then(response => {
            if (response.data.headimg == '') {
              response.data.headimg = require('../../assets/logo4.png')
            }
            commit('SET_USERINFO', response.data.data)
            resolve(state.userInfo)
          })
          .catch(error => {
            reject(error)
          })
      } else {
        resolve(state.userInfo)
      }
    })
  },
  // 微信登录
  async wechatLogin({ commit, state }, wxCode) {
    const result = await WechatLogin({
      code: wxCode
    })
    if (result.data.data.status) {
      TokenHandle(result.data.data)
      loginAfterHandle({ commit, state })
      return result
    }
    return result.data.data
  },
  // 兑换登陆
  async exchangeLogin({ commit, state }, userInfo) {
    try {
      const response = await couponAndLoginApi({
        phone: userInfo.phone,
        code: userInfo.code,
        key: userInfo.key,
        'Login-Type': 'user-coupon'
      })
      const result = response.data.data
      if (result) {
        TokenHandle(result.user_info)
        commit('SET_EXCHANGE_COUPON_INFO', {
          ...result.card_info,
          exchange_key: userInfo.key
        })
        // loginAfterHandle({ commit, state })
      }
      return result
    } catch (error) {
      throw error
    }
  },

  // 退出登录
  loginOut({ state, commit }) {
    removeToken()
    sessionStorage.clear()
    state.userInfo = ''
    state.userInte = ''
    state.userSurplus = ''
    commit('clean_main_platform') // 清空平台
    state.welfareCards = []
    commit('RESET_ALL_STATE', null, { root: true })
    router.replace({
      path: '/login'
    })
  },
  // 获取用户积分
  async getInte({ commit, state }) {
    const result = await getUserInte()
    commit('set_user_inte', result.data.data.inte)
  },
  // 获取用户余额
  async getUsersurplus({ commit, state }) {
    const result = await getUsersurplusApi()
    commit('SET_USER_SURPLUS', result.data.data.surplus)
  },
  async getBalanceList({ commit, state }, params) {
    const result = await balanceListApi({
      page: 1,
      size: 100
    })
    if (result.data.data.status) {
      state.welfareCards = result.data.data.list.data
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
